import InnerHTML from "dangerously-set-html-content";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { IconButton } from "@circle-react-uikit/HeaderV3/IconButton";
import { useListItemDataProvider } from "@circle-react-uikit/SortableList";
import { Typography } from "@circle-react-uikit/Typography";
import { I18N_ROOT } from "../";
import { useRenameFormModal } from "./RenameModal";

export const MobileHomeSegmentItem = () => {
  const renameModal = useRenameFormModal();
  const { item: segment }: any = useListItemDataProvider();
  const i18nRoot = `${I18N_ROOT}.mobile_home_segments_order`;
  const optionText =
    !segment.available &&
    t([
      I18N_ROOT,
      "mobile_home_segments_order",
      segment.kind,
      "unavailable_state_label",
    ]);

  // this is to force tooltip links to render in circle's brand color instead
  // of the community's brand color. Since tooltips live outside the SettingsApp
  // shell that forces the brand color, we need to manually set it here.
  const brandVariable: string = "--brand";
  const tooltipStyles = {
    [brandVariable]: "#506cf0",
  };

  return (
    <div className="bg-primary flex h-full justify-between px-6 py-4">
      <div className="flex items-center gap-2.5">
        <Icon type="16-reorder" size={16} />
        <Typography.LabelSm
          color={segment.available ? "text-dark" : "text-light"}
        >
          {segment.custom_name || t([i18nRoot, segment.kind, "label"])}
        </Typography.LabelSm>
      </div>
      {optionText && (
        <TippyV2
          allowHTML
          content={
            <InnerHTML
              style={tooltipStyles}
              html={t([i18nRoot, "unavailable_tooltip"], {
                path: t([i18nRoot, segment.kind, "enable_in_path"]),
              })}
            />
          }
        >
          <Typography.LabelXs color="text-light">
            {optionText}
          </Typography.LabelXs>
        </TippyV2>
      )}
      {!optionText && (
        <Dropdown
          button={
            <IconButton
              name="16-menu-dots-horizontal"
              iconClassName="!text-dark"
              ariaLabel={t([i18nRoot, "actions", "aria_label"])}
            />
          }
        >
          <Dropdown.ItemWithLink
            onClick={() => renameModal.show({ segment })}
            linkType="button"
          >
            {t([
              i18nRoot,
              "actions",
              segment.custom_name ? "edit_custom_name" : "assign_custom_name",
            ])}
          </Dropdown.ItemWithLink>
        </Dropdown>
      )}
    </div>
  );
};
